import 'css-chunk:src/index/pages/login/index.module.scss';export default {
  "login_body": "login_body__ACb1Z",
  "loginLink": "loginLink__PA6m8",
  "login_box": "login_box__vXno4",
  "login_input": "login_input__Pz3Y5",
  "pass_reset_box": "pass_reset_box__XzZqh",
  "pass_reset_input": "pass_reset_input__yuHxB",
  "pass_reset_label": "pass_reset_label__QKL4r",
  "pass_reset_button": "pass_reset_button__BGQ-3",
  "error": "error__pBDhd"
};